import { configureStore } from '@reduxjs/toolkit'
import rootReducer from '../reducers/rootReducer';

export default function configureStoreFunc(preloadedState) {
  const store = configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
    devTools: process.env.NODE_ENV === 'development',
  })

  return store
}